import { render, staticRenderFns } from "./ClientDetailsPage.vue?vue&type=template&id=0e30bf6e&scoped=true&"
import script from "./ClientDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./ClientDetailsPage.vue?vue&type=script&lang=ts&"
import style0 from "./ClientDetailsPage.vue?vue&type=style&index=0&id=0e30bf6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e30bf6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
